import { useCallback, useEffect, useRef, useState } from 'react'

export const useMounted = (): boolean => {
  const [mounted, setMounted] = useState(false)

  useEffect(() => {
    setMounted(true)
  }, [])

  return mounted
}

export interface UsePageLoadOptions {
  defer?: boolean
}

export const usePageLoad = (options: UsePageLoadOptions = {}): boolean => {
  const { defer = true } = options
  const [pageLoaded, setPageLoaded] = useState(!defer)
  const deferRef = useRef(defer)
  const handleLoad = useCallback(() => setPageLoaded(true), [])

  useEffect(() => {
    const deferValue = deferRef.current
    if (!deferValue) {
      setPageLoaded(true)
      return
    }

    if (typeof window === 'undefined') return

    if (document.readyState === 'complete') {
      handleLoad()
      return
    }

    window.addEventListener('load', handleLoad, { once: true })
    return () => {
      window.removeEventListener('load', handleLoad)
    }
  }, [handleLoad])

  return pageLoaded
}
